import { render, staticRenderFns } from "./Layout-3.vue?vue&type=template&id=7fd6f4d0&"
import script from "./Layout-3.vue?vue&type=script&lang=js&"
export * from "./Layout-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports